import type { ICartItemInput } from "@magento/types";

export const createCartItemData = (sku: string, quantity = 1, isConsentGiven?: boolean) => {
  const data: Partial<ICartItemInput> = { sku, quantity };

  if (isConsentGiven === undefined) return data;

  const entered_options = [
    {
      uid: btoa("custom-option/has_registration_consent"),
      value: isConsentGiven,
    },
  ] as unknown as ICartItemInput["entered_options"];
  // according to codegen value should be a string but actually it needs to be a boolean :/

  data.entered_options = entered_options;
  return data;
};
